// The published TECHNICIAN VISIT CHARGE, client mirror (Session AOX, superseding Session AOC's
// hourly mirror TECH_VISIT_HOUR_GBP, which stood for nine days; reshaped by Session TV2).
//
// The authoritative source is TECH_VISIT_DAY_RATE / TECH_VISIT_DAY_CAP_HOURS / TECH_VISIT_OVERAGE_HOUR
// in server/src/modules/pricing/fees.ts: that is what the published Schedule of Fees PDF renders, what the
// public rate-card JSON serves to the on-screen modal, what the MCP tool quotes, and what the DRAFT Xero
// invoice is drafted at when a completed tech visit is approved. This is the client mirror, because the
// SPA is a separate Vite bundle and cannot import server code at runtime.
//
// It exists for exactly one reason: the office "Raise..." modal (and the Connected AI page's
// description of what the assistant will quote) has to STATE the charge to the person about to
// commit a customer to it. That is the same job CONDITION_REPORT_FEE_GBP does for the GBP 510
// survey, so this follows that file's pattern deliberately rather than inventing a second one, and
// it is bound to the engine the same way, by server/src/modules/pricing/techVisitRateParity.test.ts.
//
// THE MODEL, so a reader of this file does not have to open fees.ts (Director ruling, 29 October 2026, Session TV2,
// superseding AOX): GBP 700 flat, covering up to five hours on site, ALWAYS (in or out of hours, in or out of
// contract; the GBP 1,400 special arrangement is retired). Time beyond five hours IS charged: GBP 210 an hour in
// 15-minute steps rounded up (the day rate's own hourly figure, 700 / 5, times 1.5), or, where the office chooses, as
// a further GBP 700 day. The subcontractor pay side is a different direction and is not mirrored here.
//
// NEVER RE-TYPE A FIGURE AT A CALL SITE. Two homes bound by a test is the most this codebase
// tolerates; a third, typed into a component, is the drift the parity test cannot see.
export const TECH_VISIT_DAY_RATE_GBP = 700;
export const TECH_VISIT_DAY_CAP_HOURS = 5;
export const TECH_VISIT_OVERAGE_MULTIPLIER = 1.5;
export const TECH_VISIT_OVERAGE_HOUR_GBP = Math.round((TECH_VISIT_DAY_RATE_GBP / TECH_VISIT_DAY_CAP_HOURS) * TECH_VISIT_OVERAGE_MULTIPLIER * 100) / 100;
export const TECH_VISIT_OVERAGE_STEP_MINUTES = 15;

// A small whole number in words ("five"), as the customer sentence prints it. Mirrors fees.ts numberWord (bound by techVisitRateParity.test.ts).
const NUMBER_WORDS = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "twelve"];
export function numberWord(n: number): string {
  return Number.isInteger(n) && n >= 0 && n < NUMBER_WORDS.length ? NUMBER_WORDS[n]! : String(n);
}

// "GBP 700": whole pounds with thousands grouping and no pence, which is how the
// office screens state a day rate. ICU-independent, like the PDF templates' own gbp2.
export function gbpWhole(pounds: number): string {
  return `GBP ${String(Math.round(pounds)).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
}
export const TECH_VISIT_DAY_RATE_LABEL = gbpWhole(TECH_VISIT_DAY_RATE_GBP);
export const TECH_VISIT_OVERAGE_HOUR_LABEL = gbpWhole(TECH_VISIT_OVERAGE_HOUR_GBP);
